export const hasUserSeenAiPromptBoxTemplatesTooltip = async (): Promise<boolean> => {
  if (!window.PMW.isUserLoggedIn()) {
    return false;
  }
  // CodeReviewZain: use local caching first;
  try {
    const response = (await window.PMW.readLocal('ai/hasUserSeenAiPromptBoxTemplatesTooltip')) as {hasSeen: boolean};
    return response.hasSeen;
  } catch {
    return false;
  }
};

export const markAiPromptBoxTemplatesTooltipAsSeen = async (): Promise<void> => {
  if (!window.PMW.isUserLoggedIn()) {
    return;
  }

  try {
    await window.PMW.writeLocal('ai/markAiPromptBoxTemplatesTooltipAsSeen');
  } catch {
    // best-effort; ignore failures
  }
};
